'use client';

import { useOnboardingRedirect } from '@/hooks/use-onboarding-redirect';
import type { AcquisitionIntent } from '@/lib/acquisition-intent';

export function AcquisitionOnboardingPage({ intent }: { intent: AcquisitionIntent }) {
  const { component } = useOnboardingRedirect(intent);
  return component;
}
